(() => {
  if (window.PawMyLifeStickyAtcLoaded) return;
  window.PawMyLifeStickyAtcLoaded = true;

  const init = () => {
    document.querySelectorAll('[data-pml-sticky-atc]').forEach((bar) => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';

      const info = document.querySelector(bar.dataset.productInfo);
      if (!info) return;

      const mainButton = info.querySelector('.product-form__submit');
      const stickyButton = bar.querySelector('[data-pml-sticky-button]');
      const stickyVariant = bar.querySelector('[data-pml-sticky-variant]');
      const stickyPrice = bar.querySelector('[data-pml-sticky-price]');
      const picker = info.querySelector('variant-selects');
      const mainPrice = info.querySelector('[id^="price-"]');

      const sync = () => {
        const selectedOptions = picker
          ? [...picker.querySelectorAll('input[type="radio"]:checked, select')].map((control) => control.value).filter(Boolean)
          : [];
        if (stickyVariant && selectedOptions.length) stickyVariant.textContent = selectedOptions.join(' / ');

        picker?.querySelectorAll('.pml-visual-picker').forEach((fieldset) => {
          const selectedLabel = fieldset.querySelector('[data-pml-selected-option]');
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (selectedLabel && checked) selectedLabel.textContent = checked.value;
        });
        if (mainPrice && stickyPrice) {
          const visiblePrice = mainPrice.querySelector('.price-item--sale, .price-item--regular');
          if (visiblePrice) stickyPrice.textContent = visiblePrice.textContent.trim();
        }
        if (mainButton && stickyButton) {
          stickyButton.disabled = mainButton.disabled;
          stickyButton.textContent = mainButton.disabled
            ? (mainButton.textContent.trim() || 'Choose your options')
            : 'Add to bag';
        }
      };

      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && window.innerWidth < 750;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
      }, { threshold: 0.05 });

      if (mainButton) observer.observe(mainButton);
      info.addEventListener('change', () => window.setTimeout(sync, 0));
      if (mainPrice) new MutationObserver(sync).observe(mainPrice, { subtree: true, childList: true, characterData: true });

      stickyButton?.addEventListener('click', () => {
        if (mainButton && !mainButton.disabled) {
          mainButton.click();
        } else {
          const firstPicker = info.querySelector('.product-form__input');
          firstPicker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      sync();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
